
import React from 'react'
import { SvgIcon } from '@mui/material'


export const InfoIcon = ({ sx, ...props }) => {
    return (
        <SvgIcon  {...{ sx: sx?.color ? { ...sx, stroke: sx.color, color: '#fff', display: 'flex', alignItems: 'center' } : sx, ...props }} >
            <path xmlns="http://www.w3.org/2000/svg" d="M9 6.75V9M9 11.25H9.0075M15.7529 9C15.7529 12.7279 12.7308 15.75 9.00293 15.75C7.47562 15.75 2.25347 15.75 2.25347 15.75C2.25347 15.75 3.42287 12.9421 2.95486 12.0006C2.50557 11.0967 2.25293 10.0779 2.25293 9C2.25293 5.27208 5.275 2.25 9.00293 2.25C12.7308 2.25 15.7529 5.27208 15.7529 9Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </SvgIcon>
    )
}
